import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TimelineRawComponent } from './timeline-raw.component';

@NgModule({
    declarations: [
        TimelineRawComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        TimelineRawComponent
    ]
})
export class TimelineRawModule
{ }
